"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var CATALOG_URL = 'https://vod.wix.com';
exports.PRODUCTION_HOSTS = {
    catalog: CATALOG_URL,
    files: 'https://vod-meta.wix.com',
    image: 'https://images-vod.wixmp.com',
    wixFiles: 'https://files.wix.com/files',
    paypal: 'https://dgs.wixapps.net',
    statsCollector: 'https://video-counters.wix.com',
    pixWix: 'https://pix.wix.com/services',
};
exports.DEVELOPMENT_HOSTS = exports.PRODUCTION_HOSTS;
exports.TEST_SERVER_HOSTS = tslib_1.__assign({}, exports.PRODUCTION_HOSTS, { catalog: 'https://vod-test.wix.com', files: 'https://vod-meta-test.wix.com', image: 'https://images-vod-test.wix.com', paypal: 'https://dgs-test.wixapps.net' });
//# sourceMappingURL=hosts.js.map